import { BaseModel } from "@/models/base";
import { AUTOMACAO_URL, AUTOMACAO_AMBIENTE } from "@/commons/config";
import { handleErrorResponse, handleResponse } from "@/helpers/handle-response";

import { Axios } from "axios-observable";
import { AxiosResponse, AxiosRequestConfig, AxiosInstance } from "axios";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { biometriaHandleErrorRequest, biometriaHandleRequest } from "@/helpers/biometria-handle-request";

export interface APIModel<T extends BaseModel> {
  body?: T;
  pageIndex?: number;
  pageSize?: number;
}

export class BiometriaBaseAPI<T extends BaseModel> {
  protected axios: Axios;
  protected urlAutomacao: string;
  protected ambienteAutomacao: string;

  constructor() {
    this.axios = this.buildAxiosInstance();
    //Inicializando variáveis de ambiente automacao.arce
    this.urlAutomacao = AUTOMACAO_URL;
    this.ambienteAutomacao = AUTOMACAO_AMBIENTE;
  }

  public getAll(): AxiosObservable<T[]> {
    return this.axios.get(`${this.urlAutomacao}`);
  }

  public paginator(model: APIModel<T>): AxiosObservable<any> {
    return this.axios.post(
      `${this.urlAutomacao}/find?` +
        `${this.getNumberPage(model.pageIndex)}&` +
        `${this.getNumberRegistries(model.pageSize)}`,
      model.body
    );
  }

  public show(id: number): AxiosObservable<T> {
    return this.axios.get(`${this.urlAutomacao}/${id}`);
  }

  public create(body: T): AxiosObservable<T> {
    return this.axios.post(`${this.urlAutomacao}/`, body);
  }

  public update(id: number, body: T): AxiosObservable<T> {
    return this.axios.put(`${this.urlAutomacao}/${id}`, body);
  }

  public delete(id: number): AxiosObservable<any> {
    return this.axios.delete(`${this.urlAutomacao}/${id}`);
  }

  protected getNumberPage(pageIndex = 0): string {
    return `page=${pageIndex}`;
  }

  protected getNumberRegistries(pageSize = 15): string {
    return `size=${pageSize}`;
  }

  protected mapEntity(data: any): any {
    const { entry } = data;
    return {
      ...entry
    };
  }

  private buildAxiosInstance(): Axios {
    const axiosInstance = Axios.create({});
    this.requestInterceptor(axiosInstance);
    this.responseInterceptor(axiosInstance);

    return axiosInstance;
  }

  private requestInterceptor(axios: Axios): void {
    axios.interceptors.request.use(
      (config: AxiosRequestConfig) => biometriaHandleRequest(config),
      (error: any) => biometriaHandleErrorRequest(error)
    );
  }

  private responseInterceptor(axios: Axios): void {
    axios.interceptors.response.use(
      (response: AxiosResponse) => handleResponse(response),
      (error: any) => handleErrorResponse(error)
    );
  }
}
